export default "__VITE_PUBLIC_ASSET__676f7817__"